import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";

import { MyAuthService } from "../../authentication/auth.service";
import { ApiService } from "../../services/api.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-add-client-form",
  templateUrl: "./add-client-form.component.html",
  styleUrls: ["./add-client-form.component.scss"]
})
export class AddClientFormComponent implements OnInit {
  @Output() hideAddClient = new EventEmitter<boolean>();
  public userInfo: any;
  public show = false;
  public showCloseBtn = true;
  public countryCodes: any;
  public dialCode = "+91";
  public regForm: FormGroup;
  public isSubmitted = false;
  public verifyOtpError = "";
  public successMsg = "Your Mobile number is verified successfully!";
  constructor(
    private _toast: ToastrService,
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    private _auth: MyAuthService //private _api: ApiService
  ) {
    this._auth.userData.subscribe(userInfo => {
      this.userInfo = userInfo;
    });
  }

  ngOnInit() {
    this.createForm();
  }

  get formControls() {
    return this.regForm.controls;
  }
 

  private createForm() {
    this.regForm = new FormGroup({
      email: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.email])
      ),
      mobile: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[6-9][0-9]{9}$")
        ])
      )
    });
  }

  addClient() {
    console.log("## addClient Call ##");
    this.isSubmitted = true;
    if (this.regForm.invalid) {
      return;
    }
    console.log(
      "first",
      this.regForm.value.email,
      this.regForm.value.mobile,
      this.userInfo
    );
    if (this.regForm.valid) {
      const data = {
        mobile_number: this.regForm.value.mobile,
        email: this.regForm.value.email,
        partner_object_id: this.userInfo.identity._id,
        p_id: this.userInfo.identity.p_id
      };
      console.log("Form Data: ", data);
      //return;
      try {
        this.apiService.addPartnerClient(data).subscribe(
          res => {
            console.log("Add Partner Client ::: Res ::: ", res);
            //this.isSubmitted = false;
            if (res.status === "success") {
              this._toast.success(res.message);
              this.close();
            } else {
              this._toast.error(res.message);
            }
          },
          err => {
            console.log("Add Partner Client ::: err ::: ", err, err.headers);
            if (err.error) {
              this._toast.error(err.error);
            }
          }
        );
      } catch (error) {
        console.log("Add Partner Client ::: error ::: ", error);
        this._toast.error(error);
      }
    }
  }

  close() {
    //this._shared.toggleMobileVerify(null);
    this.hideAddClient.emit(false);
  }
}
